import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {BookingFlowStepsStore} from './types';

export const useBookingFlowStepsStore = create<BookingFlowStepsStore>()(
	persist(
		set => ({
			bookingStep: 0,

			setBookingStep: step =>
				set(state => ({
					bookingStep: typeof step === 'function' ? step(state.bookingStep) : step,
				})),

			resetBookingStep: () =>
				set({
					bookingStep: 0,
				}),
		}),
		{
			name: 'bookingFlowStep',
		},
	),
);
